import React from 'react';
import "./professorBox.css";
import {ENV} from "../../services/env";
const ProfessorBox = (props) => {
    return (
        <div className={"professor-box"}>
            <img src={ENV.API.IMG + props.image}/>
            <div className={"professor-box-section"}>
               <h4> {props.title}</h4>
                <div className={"professor-box-section-des"} dangerouslySetInnerHTML={{__html:props.des}}/>
            </div>
        </div>
    );
};

export default ProfessorBox;
